// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/DSC06297.JPG", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/DSC06375.JPG", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/DSC06439.JPG", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.animation{
    width: 300px;
    position: relative;
    animation: mymove 20s linear infinite;
}
@keyframes mymove {
    from {left: 0%;}
    to {left: 100%;}
}

header {
    /* background-color: rgba(14, 14, 75, .4); */
    background-color: rgba(0, 0, 0, .4);
}
.nav-item:hover .nav-item__child {
    display: flex;
}

.nav-item::before {
    content: '';
    display: block;
    transform: translateY(-40px);
    width: 100%;
    height: 4px;
    background-color: transparent;
    transition: background-color ease .3s;
}
.nav-item:hover::before{
    background-color: #00ce87;
}
.nav-item__child:hover {
    display: flex;
}

.slide_1 {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center no-repeat;
    background-size: cover;
}

.slide_2 {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) center no-repeat;
    background-size: cover;
}

.slide_3 {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) center no-repeat;
    background-size: cover;
}

.swiper h1 {
    z-index: 50 !important;
}

.menus {
    display: flex;
    list-style: none;
}

.menu-items {
    position: relative;
    font-size: 17px;
}

.menu-items a {
    display: block;
    font-size: inherit;
    color: inherit;
    text-decoration: none;
}

.menu-items button {
    color: inherit;
    font-size: inherit;
    border: none;
    background-color: transparent;
    cursor: pointer;
    width: 100%;
}

.menu-items a,
.menu-items button {
    text-align: left;
    padding: 0.7rem 1rem;
}

.menu-items a:hover,
.menu-items button:hover {
    background: #FFF;
    color: #000;
}

.dropdown {
    position: absolute;
    left: auto;
    font-size: 0.875rem;
    z-index: 9999;
    min-width: 12rem;
    padding: 0.5rem 0;
    list-style: none;
    background-color: #0008;
    border-radius: 0.5rem;
    transition: all 0.3s;
}

.dropdown.show {
    display: block!important;
}

.dropdown.dropdown .submenu {
    position: absolute;
    left: 100% !important;
}

.menu-items .dropdown .menu-items .dropdown-submenu {
    left: 100% !important;
}

.menu-items .active {
    /* background: #0E0E4B; */
    color: #fff;
}

.dropdown.dropdown-submenu.show {
    left: 100%;
    top: 0;
}


@media screen and (max-width: 1200px) {
    .container {
        padding-left: 4rem;
        padding-right: 4rem;
    }
    .desktop {
        display: none;
    }
    .mobile {
        display: block;
    }
    .menus {
        flex-direction: column;
    }
    .hamBox {
        width: 30px;
        height: 30px;
        padding: 2.4rem 0;
    }
    .dropdown {
        top: 90%;
        /* left: 0;
        right: 0; */
        min-width: 80%;
    }
}

@media screen and (max-width: 425px) {
    body #ym-informer {
        left: 0 !important;
        width: 425px !important;
    }
    footer .box-child {
        width: 100% !important;
    }
    .news .swiper-slide,
    .products .swiper-slide,
    .news_details .swiper-slide {
        width: 100%;
    }
    .preloader .text {
        left: calc(50% + 350px);
    }
    .common_title {
        font-size: 16px !important;
        line-height: 1rem !important;
    }
    .fotos {
        width: 100% !important;
    }
    .products {
        width: 100% !important;
    }
    .news .products {
        width: 100% !important;
    }
    /*.dropdown {*/
    /*    top: 90% !important;*/
    /*    left: 0;*/
    /*    right: 0;*/
    /*    min-width: 80%;*/
    /*}*/
    .dropdown .menu-items {
        font-size: 15px;
    }
    .products .swiper-pagination-bullet:nth-child(even) {
        display: none;
    }
    .language {
        right: 2.5rem !important;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/header/index.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,kBAAkB;IAClB,qCAAqC;AACzC;AACA;IACI,MAAM,QAAQ,CAAC;IACf,IAAI,UAAU,CAAC;AACnB;;AAEA;IACI,4CAA4C;IAC5C,mCAAmC;AACvC;AACA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,4BAA4B;IAC5B,WAAW;IACX,WAAW;IACX,6BAA6B;IAC7B,qCAAqC;AACzC;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,aAAa;AACjB;;AAEA;IACI,oEAA6D;IAC7D,sBAAsB;AAC1B;;AAEA;IACI,oEAA6D;IAC7D,sBAAsB;AAC1B;;AAEA;IACI,oEAA6D;IAC7D,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,YAAY;IACZ,6BAA6B;IAC7B,eAAe;IACf,WAAW;AACf;;AAEA;;IAEI,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;;IAEI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;IACvB,qBAAqB;IACrB,oBAAoB;AACxB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,UAAU;IACV,MAAM;AACV;;;AAGA;IACI;QACI,kBAAkB;QAClB,mBAAmB;IACvB;IACA;QACI,aAAa;IACjB;IACA;QACI,cAAc;IAClB;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,WAAW;QACX,YAAY;QACZ,iBAAiB;IACrB;IACA;QACI,QAAQ;QACR;mBACW;QACX,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,uBAAuB;IAC3B;IACA;QACI,sBAAsB;IAC1B;IACA;;;QAGI,WAAW;IACf;IACA;QACI,uBAAuB;IAC3B;IACA;QACI,0BAA0B;QAC1B,4BAA4B;IAChC;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,sBAAsB;IAC1B;IACA,cAAc;IACd,2BAA2B;IAC3B,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,IAAI;IACJ;QACI,eAAe;IACnB;IACA;QACI,aAAa;IACjB;IACA;QACI,wBAAwB;IAC5B;AACJ","sourcesContent":[".animation{\n    width: 300px;\n    position: relative;\n    animation: mymove 20s linear infinite;\n}\n@keyframes mymove {\n    from {left: 0%;}\n    to {left: 100%;}\n}\n\nheader {\n    /* background-color: rgba(14, 14, 75, .4); */\n    background-color: rgba(0, 0, 0, .4);\n}\n.nav-item:hover .nav-item__child {\n    display: flex;\n}\n\n.nav-item::before {\n    content: '';\n    display: block;\n    transform: translateY(-40px);\n    width: 100%;\n    height: 4px;\n    background-color: transparent;\n    transition: background-color ease .3s;\n}\n.nav-item:hover::before{\n    background-color: #00ce87;\n}\n.nav-item__child:hover {\n    display: flex;\n}\n\n.slide_1 {\n    background: url('../../assets/DSC06297.JPG') center no-repeat;\n    background-size: cover;\n}\n\n.slide_2 {\n    background: url('../../assets/DSC06375.JPG') center no-repeat;\n    background-size: cover;\n}\n\n.slide_3 {\n    background: url('../../assets/DSC06439.JPG') center no-repeat;\n    background-size: cover;\n}\n\n.swiper h1 {\n    z-index: 50 !important;\n}\n\n.menus {\n    display: flex;\n    list-style: none;\n}\n\n.menu-items {\n    position: relative;\n    font-size: 17px;\n}\n\n.menu-items a {\n    display: block;\n    font-size: inherit;\n    color: inherit;\n    text-decoration: none;\n}\n\n.menu-items button {\n    color: inherit;\n    font-size: inherit;\n    border: none;\n    background-color: transparent;\n    cursor: pointer;\n    width: 100%;\n}\n\n.menu-items a,\n.menu-items button {\n    text-align: left;\n    padding: 0.7rem 1rem;\n}\n\n.menu-items a:hover,\n.menu-items button:hover {\n    background: #FFF;\n    color: #000;\n}\n\n.dropdown {\n    position: absolute;\n    left: auto;\n    font-size: 0.875rem;\n    z-index: 9999;\n    min-width: 12rem;\n    padding: 0.5rem 0;\n    list-style: none;\n    background-color: #0008;\n    border-radius: 0.5rem;\n    transition: all 0.3s;\n}\n\n.dropdown.show {\n    display: block!important;\n}\n\n.dropdown.dropdown .submenu {\n    position: absolute;\n    left: 100% !important;\n}\n\n.menu-items .dropdown .menu-items .dropdown-submenu {\n    left: 100% !important;\n}\n\n.menu-items .active {\n    /* background: #0E0E4B; */\n    color: #fff;\n}\n\n.dropdown.dropdown-submenu.show {\n    left: 100%;\n    top: 0;\n}\n\n\n@media screen and (max-width: 1200px) {\n    .container {\n        padding-left: 4rem;\n        padding-right: 4rem;\n    }\n    .desktop {\n        display: none;\n    }\n    .mobile {\n        display: block;\n    }\n    .menus {\n        flex-direction: column;\n    }\n    .hamBox {\n        width: 30px;\n        height: 30px;\n        padding: 2.4rem 0;\n    }\n    .dropdown {\n        top: 90%;\n        /* left: 0;\n        right: 0; */\n        min-width: 80%;\n    }\n}\n\n@media screen and (max-width: 425px) {\n    body #ym-informer {\n        left: 0 !important;\n        width: 425px !important;\n    }\n    footer .box-child {\n        width: 100% !important;\n    }\n    .news .swiper-slide,\n    .products .swiper-slide,\n    .news_details .swiper-slide {\n        width: 100%;\n    }\n    .preloader .text {\n        left: calc(50% + 350px);\n    }\n    .common_title {\n        font-size: 16px !important;\n        line-height: 1rem !important;\n    }\n    .fotos {\n        width: 100% !important;\n    }\n    .products {\n        width: 100% !important;\n    }\n    .news .products {\n        width: 100% !important;\n    }\n    /*.dropdown {*/\n    /*    top: 90% !important;*/\n    /*    left: 0;*/\n    /*    right: 0;*/\n    /*    min-width: 80%;*/\n    /*}*/\n    .dropdown .menu-items {\n        font-size: 15px;\n    }\n    .products .swiper-pagination-bullet:nth-child(even) {\n        display: none;\n    }\n    .language {\n        right: 2.5rem !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
